import { render, staticRenderFns } from "./AddShift.vue?vue&type=template&id=e371ad38&"
import script from "./AddShift.vue?vue&type=script&lang=js&"
export * from "./AddShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VContainer,VIcon,VListItem,VListItemAction,VListItemContent,VListItemIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e371ad38')) {
      api.createRecord('e371ad38', component.options)
    } else {
      api.reload('e371ad38', component.options)
    }
    module.hot.accept("./AddShift.vue?vue&type=template&id=e371ad38&", function () {
      api.rerender('e371ad38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scheduling/panels/daily_schedule/AddShift.vue"
export default component.exports